import { BrowserRouter, Route, Routes } from "react-router-dom"
import { usePreloadImages } from "./hooks/usePreloadImages"
import { CaliforniaPage } from "./pages/CaliforniaPage"
import { CeremonyPage } from "./pages/CeremonyPage"
import { FloridaPage } from "./pages/FloridaPage"
import { NotFoundPage } from "./pages/NotFoundPage"
import { RegistryPage } from "./pages/RegistryPage"
import { SplashPage } from "./pages/SplashPage"
import { UsPage } from "./pages/UsPage"

function App() {
  usePreloadImages()

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SplashPage />} />
        <Route path="/us" element={<UsPage />} />
        <Route path="/california" element={<CaliforniaPage />} />
        <Route path="/ceremony" element={<CeremonyPage />} />
        <Route path="/florida" element={<FloridaPage />} />
        <Route path="/registry" element={<RegistryPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
